import React, { useRef, useState } from "react";
import { useParams } from "react-router-dom";
import AgentAiChat from "../AIChat/AgentAiChat";
import { BsInfo } from "react-icons/bs";
import { useLanguage } from "../Translations/LenguageContext";
import { TbLayoutSidebarLeftExpand, TbLayoutSidebarRightExpandFilled } from "react-icons/tb";
import { BiRocket } from "react-icons/bi";
import { IoCodeSlash, IoLaptopOutline, IoPhonePortraitOutline } from "react-icons/io5";
import CodeTreeLoader from "../Loaders/CodeTreeLoader";
import CircleBackground from "../Components/CircleBackground";
import EditorTerminal from "../MCPs/EditorTerminal";
import CircleBackgroundScale from "../Components/SquareBackground";

const OpenAppWorkspace = () => {
    const { t } = useLanguage()
    const { type, app_id, version } = useParams()
    const chatEndRef = useRef(null);
    const [openAiChat, setOpenAichat] = useState(true)
    const [loadingAppData, setLoadingAppData] = useState(false)
    const [appData, setAppData] = useState(false)
    const [activeFile, setActiveFile] = useState("")
    const [screenSwitch, setScreenSwitch] = useState("code")
    const [editorTheme, setEditorTheme] = useState("vs-dark");


    const toggleCodeView = () => setOpenAichat(!openAiChat);

    return (
        <div className="main_mcp_cont">
            <div className={`main_mcp_cont_chat ${openAiChat ? "chat_shrunk" : ""}`}>
                <div className="main_mcp_cont_chat_header">
                    <div className="main_mcp_cont_chat_btn_cont" >

                        {loadingAppData ? (
                            <button className="main_mcp_cont_chat_p fade-in main_mcp_cont_chat_btn_loading"></button>
                        ) : (
                            appData.app_name ? (
                                <p className="main_mcp_cont_chat_title fade-in" onClick={() => setActiveFile("")}>{appData.app_name}</p>
                            ) : (
                                <p className="main_mcp_cont_chat_title" onClick={() => setActiveFile("")}>App builder</p>
                            )
                        )}
                    </div>
                    <div className="main_mcp_cont_chat_btn_cont">
                        {!appData.app_name ? (
                            <>

                                {/* <button className="main_mcp_cont_chat_btn fade-in" onClick={() => setOpenInfoModal(true)}>
                                        <BsInfo />
                                    </button> */}
                                <div className="app_screen_prev_switch_cont">
                                    <button
                                        className={`app_screen_prev_switch ${screenSwitch == "code" && "app_screen_prev_switch_selected fade-in"}`}
                                        onClick={() => setScreenSwitch("code")}
                                    ><IoCodeSlash /></button>
                                    <button
                                        className={`app_screen_prev_switch ${screenSwitch == "phone" && "app_screen_prev_switch_selected fade-in"}`}
                                        onClick={() => setScreenSwitch("phone")}
                                    ><IoPhonePortraitOutline /></button>
                                    <button
                                        className={`app_screen_prev_switch ${screenSwitch == "pc" && "app_screen_prev_switch_selected fade-in"}`}
                                        onClick={() => setScreenSwitch("pc")}
                                    ><IoLaptopOutline /></button>
                                </div>
                                <button className={`main_mcp_cont_chat_btn`}>
                                    <BiRocket /> Publish
                                </button>
                            </>
                        ) : (
                            <>
                                <button className="main_mcp_cont_chat_btn fade-in main_mcp_cont_chat_btn_loading"></button>
                            </>
                        )}
                        <button className="main_mcp_cont_chat_btn fade-in" onClick={toggleCodeView}>
                            {openAiChat ? <TbLayoutSidebarLeftExpand /> : <TbLayoutSidebarRightExpandFilled />}
                        </button>
                    </div>
                </div>
                {screenSwitch == "code" ? (

                    <div className="mcp_editor_sidebar_cont">
                        <div className="filetree_editor">
                            <div className="filetree_editor_header">
                                {appData.mcp_name && (
                                    <>
                                        {/* <button className={`filetree_editor_header_btn fade-in ${(statusMcp == "DEPLOYING" || loadingSave) ? "filetree_editor_header_btn_loading" : ""}`} onClick={handleSave} disabled={(statusMcp == "DEPLOYING" || loadingSave)}>
                                            {loadingSave ? (
                                                <Spinner loading={true} />
                                            ) : (
                                                <BiSave />
                                            )}
                                        </button>
                                        <button className={`filetree_editor_header_btn fade-in`} onClick={handleOpenSaveModal} disabled={(loadingSave)}><VscSettingsGear /></button> */}
                                    </>
                                )}
                            </div>
                            <div className="filetree_body">
                                {/* {loadingAppData ? (
                                    <CodeTreeLoader files={files} />
                                ) : (
                                    Object.keys(files).map((file) => (
                                        <div
                                            key={file}
                                            className={`file_item fade-in ${activeFile === file ? "active" : ""}`}
                                            onClick={() => setActiveFile(file)}
                                        >
                                            {file.endsWith(".py") && <FaPython />}
                                            {file.endsWith(".js") && <FaNodeJs />}
                                            {file.endsWith(".json") && <VscJson />}
                                            {file.endsWith(".txt") && <FiFileText />}
                                            {file.startsWith("Dockerfile") && <FaDocker />}
                                            {!file.match(/\.(py|js|json|txt)$/) && file !== "Dockerfile" && <FiFileText />}

                                            <span >{file}</span>
                                        </div>
                                    ))
                                )} */}
                            </div>
                            <div className={`file_tree_versions ? ${"" ? "" : "file_tree_versions_closed"}`}>
                                <div className="file_tree_versions_header" >
                                    {/* <i className={`fa-solid fa-chevron-${openVersions ? "down" : "right"}`}></i> */}
                                    <p className="file_tree_versions_title">{t.abilities.versioning}</p>
                                </div>

                                {/* {versions.length == 0 ? (
                                    <div className="version_item_cont">
                                        {loadingAppData ? (
                                            <VersioningLoader length={3} version="" />
                                        ) : (
                                            <div
                                                className={`version_item fade-in ${version_n == 0 ? "version_item_selected" : ""}`}
                                                onClick={() => handleOpenVersion(0)}
                                            >
                                                v0
                                            </div>
                                        )}
                                    </div>
                                ) : (
                                    <div className="version_item_cont">
                                        {loadingAppData && (Number(mcpData.drafted_version) + 1) == draftedVersion && (
                                            <VersioningLoader length={1} version={`v${Number(mcpData.drafted_version) + 1}`} />
                                        )}

                                        {loadingSave && (
                                            <div className="version_item no_drop">
                                                v{Number(mcpData.drafted_version) + 1}
                                                <span className="version_item_span fade-in">
                                                    {t.abilities.saving}
                                                    <Spinner loading={true} />
                                                </span>
                                            </div>
                                        )}
                                        {versions
                                            .slice()
                                            .sort((a, b) => b - a)
                                            .map((version) => (
                                                <div
                                                    className={`version_item  ${version_n == version ? "version_item_selected" : ""}`}
                                                    onClick={() => handleOpenVersion(version)}
                                                >
                                                    v{version}
                                                    <div className="version_item_span_cont">

                                                        {(mcpData.version == version && statusMcp == "DEPLOYED") && (
                                                            <span className="version_item_span fade-in">
                                                                {t.abilities.published}
                                                            </span>
                                                        )}


                                                        {(mcpData.version == version && statusMcp == "DEPLOYING") && (
                                                            <span className="version_item_span fade-in">
                                                                <Spinner loading={true} />
                                                            </span>
                                                        )}

                                                        {(version_n == version && (loadingAppData && (statusMcp != "DEPLOYING"))) && (
                                                            <span className="version_item_span">
                                                                <Spinner loading={true} />
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            ))}
                                    </div>
                                )} */}
                            </div>
                        </div>
                        <div className={`mcp_editor_wrapper ${editorTheme == "vs-dark" ? "mcp_editor_wrapper_dark" : "mcp_editor_wrapper_light"}`}>

                            {/* {loadingMcpData ? (
                                                <CodeLinesLoader />
                                            ) : ( */}
                            {false ? (
                                <div className="editor_cont">
                                    {/* <Editor
                                        key={`${editorTheme}-${runtime}-${mcp_id}`}
                                        language={getEditorLanguage()}
                                        theme={editorTheme}
                                        value={files[activeFile] || ""}
                                        onChange={handleEditorChange}
                                        options={{
                                            fontSize: 12,
                                            minimap: { enabled: false },
                                            automaticLayout: true,
                                            fontFamily: "'JetBrains Mono', monospace",
                                            padding: { top: 20 },
                                        }}
                                    /> */}
                                </div>
                            ) : (
                                <CircleBackgroundScale>
                                    <div className="empty_file_editor">
                                        <div className="empty_file_editor_desc_cont">
                                            <p className="empty_file_editor_title">{t.abilities.welcome_title}</p>
                                            <p className="empty_file_editor_title_desc">
                                                {t.abilities.welcome_subtitle}
                                            </p>
                                        </div>
                                    </div>
                                </CircleBackgroundScale>
                            )}
                            {/* )} */}

                            {/* <EditorTerminal
                                openTerminal={"openTerminal"}
                                setOpenTerminal={"setOpenTerminal"}
                                fetchMcpLogs={"fetchMcpLogs"}
                                logLoading={"logLoading"}
                                statusMcp={"statusMcp"}
                                mcpData={"mcpData"}
                                mcpLogs={"mcpLogs"}
                                loadingSave={"loadingSave"}
                            /> */}
                        </div>
                    </div>
                ) : screenSwitch == "phone" ? (
                    <div className="mcp_editor_sidebar_cont">
                        <div className="phone_prev">
                            <div className="phone_iframe_speaker"></div>
                            <div className="phone_search_bar_preview"></div>
                            <div className="phone_screen">
                                <iframe
                                    className="phone_iframe"
                                    src="https://www.projecte8.com"
                                    title="Website preview"
                                    frameBorder="0"
                                >

                                </iframe>
                            </div>
                        </div>
                    </div>
                ) : (
                     <div className="mcp_editor_sidebar_cont">
                        <div className="pc_prev">
                            <div className="phone_search_bar_preview"></div>
                            <div className="pc_screen">
                                <iframe
                                    className="pc_iframe"
                                    src="https://www.projecte8.com"
                                    title="Website preview"
                                    frameBorder="0"
                                >

                                </iframe>
                            </div>
                        </div>
                    </div>
                )}

            </div>
            <AgentAiChat
                type={"MCP"}
                account_id={"account_id"}
                openAiChat={openAiChat}
                messages={[]}
                chatEndRef={chatEndRef}
                handleSendMessage={"handleSendMessage"}
                handleStopMessage={"handleStopMessage"}
                input={"input"}
                setInput={"setInput"}
                handleKeyDown={"handleKeyDown"}
                isLoading={"isLoading"}
                errorAi={"errorAi"}
                chatData={{}}
                setChatId={"setChatId"}
                chatId={"chatId"}
                loadingChats={"loadingChats"}
                loadingChatHistory={"loadingChatHistory"}
                fetchChatHistory={"fetchChatHistory"}
                steps={"steps"}
                fetchSingleChat={"fetchSingleChat"}
                isSearchEnabled={"isSearchEnabled"}
                setIsSearchEnabled={"setIsSearchEnabled"}
                isAutotestEnabled={"isAutotestEnabled"}
                setIsAutotestEnabled={"setIsAutotestEnabled"}
                statusMcp={"statusMcp"}
                inputRef={chatEndRef}
                handleInput={"handleInput"}
                selectedModel={"selectedModel"}
                setSelectedModel={"setSelectedModel"}

                mcpData={"mcpData"}
                setSelectedMcp={"setSelectedMcp"}
                handleOpenConnect={"handleOpenConnect"}
                handleOpenDisconnect={"handleOpenDisconnect"}
                setOpenErrDepModal={"setOpenErrDepModal"}
                fetchMcpData={"fetchMcpData"}
                loadingMcpData={"loadingMcpData"}
                startRunTest={"startRunTest"}
                loadingRunTest={"loadingRunTest"}
            />
        </div>
    )
}

export default OpenAppWorkspace